import axios from "axios";
import { LoginData, LoginResponse } from "../types/loginData";

export async function login(loginData: LoginData): Promise<LoginResponse> {
  try {
    const apiUrl = `${process.env.REACT_APP_API_DOMAIN}/manager/login`;
    const response = await axios.post<LoginResponse>(apiUrl, loginData);
    return response.data;
  } catch {
    throw new Error("Usuário ou senha incorretos!");
  }
}

export async function logout() {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("Token de autenticação não encontrado");
    }

    const apiUrl = `${process.env.REACT_APP_API_DOMAIN}/manager/logout`;
    await axios.post(
      apiUrl,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ).then( () => {
      localStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
    }
      
    );
  } catch (error) {
    console.error("Erro ao fazer logout:", error);
    throw new Error("Erro ao fazer logout");
  }
}